// extracted by mini-css-extract-plugin
module.exports = {"bf-tooltip":"bf-tooltip__287DI","view-only-circle":"view-only-circle__VZvaf"};